import Button from '@mui/material/Button';

export default function ButtonUsage() {
  return (
    // @focus @padding 2
    <Button variant="contained">Hello world</Button>
  );
}
